<template>
  <div class="nr">
    <!-- 問題表示欄 -->
    <div class="page-content">
      <!-- 回答選択欄 -->
      <transition name="fade">
        <div class="fixed flexrow">
          <div class="toparea-text inner">
            <div v-if="isEnvironmentPc()" class="flexstretch" v-show="showAnswers">
              <div v-for="(item, index) in selectAnswers" :key="'answerKey' + index" @click="checkAnswer(getRunmodeText(item))"
                   class="item" :class="[getNRSelectFontSize(item), { active: activeCorrectAnswer(getRunmodeText(item)) }]">
                <span v-if="runmode === 'NR1'" v-html="getSelectListText(item)"></span>
                <span v-else v-html="getPopupTextElem(getSelectListText(item))"></span>
              </div>
            </div>
            <div v-else class="flexstretch" :style="{ visibility: showAnswers ? 'visible' : 'hidden' }">
              <div v-for="(item, index) in selectAnswers" :key="'answerKey' + index" @click="checkAnswer(getRunmodeText(item))"
                   class="item" :class="{ active: activeCorrectAnswer(getRunmodeText(item)) }">
                <span v-html="getSelectListText(item)" />
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!-- actブロック -->
      <div class="inner" id="js-nr-acts" :style="nrStyles">
        <transition-group name="fade" tag="div">
          <div class="flexbox" v-for="(act, index) in dispActBlockList" :key="'actKey' + index">
            <div class="thumb item" :style="getThumbPath(index, act.image)" />
            <div class="item answer">
                <div v-if="isShowCorrectImg(index) || isShowIncorrectImg(index)"
                     :class="{ correct: isShowCorrectImg(index), incorrect: isShowIncorrectImg(index) }" />
                <div class="_item">
                  <template v-if="runmode === mixinConstants.RUNMODE_NR1">
                    <!-- NR1 -->
                    <p :class="[isEnvironmentPc() ? getNRFontSize(act) : '', { active: isActActive(index) }]">
                      <span v-html="getPopupTextElem(getLangText(act))" />
                    </p>
                  </template>
                  <template v-else>
                    <!-- NR2 -->
                    <p v-if="showAnswerLabel(index)" :class="[isEnvironmentPc() ? getNRFontSize(act) : '', { active: isActActive(index) }]">
                      <span v-html="getPopupTextElem(getLangText(act))" />
                    </p>
                    <div class="q-blank" v-if="!showAnswerLabel(index)">
                      <p :class="[isEnvironmentPc() ? getNRFontSize(act) : '']">
                        <span v-html="getPopupTextElem(getQuestionBlankText(act))" />
                      </p>
                    </div>
                  </template>
                  <button class="icon-voice" v-on:click="audioReplay(act.sounds[0])" :disabled="disableReplayButton(index)"></button>
                </div>
            </div>
          </div>
        </transition-group>
      </div><!-- /.inner -->
    </div><!-- /.page-content -->
  </div>
</template>
<script>
import runmode from "@/mixin/runmode_nr";
import * as constants from "@/store/constants";
import * as mixinConstants from "@/mixin/constants";

var lodash = require("lodash");

export default {
  name: "NR1",
  mixins: [
    runmode
  ],
  data() {
    return {
      // 選択回答一覧表示用
      selectAnswers: [],
      // 回答一覧表示
      showAnswers: false
    };
  },
  computed: {
    mixinConstants: function() {
      return mixinConstants;
    }
  },
  methods: {
    init: function() {
      const self = this;

      this.runmode = this.pathstep.mode;

      // 正解音終了処理
      this.myAudioCollect.onended = function() {
        self.audioCollectEnded();
      };
      // 初回ACT追加
      this.dispActBlockList.push(_.clone(this.currentAct));
      // 初回音声再生
      if (this.lessonState == constants.LESSON_STATE_START) {
        // STARTの場合、初回音声再生
        this.divideChallenge();
      } else {
        // 初回再生待ち
        this.waitingStart = true;
      }

      // 自動調整初期処理
      this.initAutoAdjustNR();
    },
    audioCollectEnded: function() {
      const self = this;

      // 正解音終了処理
      this.isCorrectPlaying = false;
      // 正解画像非表示
      this.showCorrectImg = false;
      // 次のACT表示処理
      this.nextTimer = setTimeout(function() {
        self.nextAct();
      }, 1000);
    },
    audioEnded: function() {
      const self = this;

      // 再生終了時処理
      this.log("audio ended" + this.runmode);
      if (this.isAudioQuestionPlaing) {
        // スマホ表示の場合、自動サイズ調整処理を実行
        if (!this.isEnvironmentPc()) {
          this.autoAdjustTopArea();
          this.applyTopAreaSize();
        }
        // 問題再生終了処理
        this.showAnswers = true;
        this.enableAudioReplay = true;
      } else if (!this.isAudioReplay) {
        // リプレイではない
        this.nextTimer = setTimeout(function() {
          // 次のACT表示処理
          self.nextAct();
        }, 1000);
      }
      // フラグ初期化
      this.isAudioQuestionPlaing = false;
      this.isAudioReplay = false;
    },
    nextAct: function() {
      const self = this;

      // 次のACT表示
      this.nextTimer = null;
      if (this.setNextAct(function() {
        this.dispActBlockList.push(_.clone(self.currentAct));
        this.$nextTick(function() {
          // ACTの表示エリアがスクロールした場合、画面下に移動
          $("#js-nr-acts").animate({ scrollTop: $("#js-nr-acts")[0].scrollHeight }, "first", function() {
            // 回答分岐
            self.divideChallenge();
          });
        });
      })) {
      } else {
        // pathstep終了
        this.setInterval(mixinConstants.ALLCORRECT_INTERVAL).then(function() {
          self.$emit("endAct");
        });
      }
    },
    divideChallenge: function() {
      // 回答有無振り分け
      if (this.isChallenge(this.currentAct)) {
        // 回答あり
        // 問題再生フラグ
        this.isAudioQuestionPlaing = true;
        // 選択肢取得
        this.selectAnswers = this.getSelectList();
      } else {
        // 回答なし
      }
      // 音声再生
      if (this.lessonState == constants.LESSON_STATE_PAUSE) {
        // レッスン停止中
        this.stopNextAct = true;
      } else {
        this.audioPlay(this.currentAct.sounds[0]);
      }
    },
    getSelectList: function() {
      // 選択項目のリスト生成
      var list = [];
      for (var i = 0; i < this.pathstep.acts.length; i++) {
        // challengeで現在のACT以外
        if (this.isChallenge(this.pathstep.acts[i]) && i !== this.currentActIndex) {
          list.push(_.clone(this.pathstep.acts[i]));
        }
        // 最大2つ
        if (list.length == 2) {
          break;
        }
      }
      list.push(_.clone(this.currentAct));
      return _.shuffle(list);
    },
    getRunmodeText: function(act) {
      // Runmodeごとの言語テキスト取得
      if (this.runmode == mixinConstants.RUNMODE_NR1) {
        // NR1
        return act.japaneseText;
      } else {
        // NR2
        return act.basicText;
      }
    },
    getSelectListText: function(act) {
      // 選択欄テキスト取得
      if (this.runmode == mixinConstants.RUNMODE_NR1) {
        return this.getRunmodeText(act);
      } else {
        return this.getLangText(act);
      }
    },
    checkAnswer: function(answer) {
      const self = this;

      // 答え合わせ
      if (this.dispAllAnswerStatus == true || this.dispJapaneseStatus == true) {
        // 全解答表示中、日本語表示中は何もしない
        return;
      }

      var text = this.getRunmodeText(this.currentAct);
      this.showCorrectImg = false;
      this.showIncorrectImg = false;
      if (answer === text) {
        // 正解
        // 音声停止
        this.runmodeAudioPause();
        this.isAudioReplay = false;
        // 正解配列にindex追加（すでに不正解してない場合）
        if (!_.includes(this.incorrectIndex, this.currentActIndex)) {
          this.correctIndex.push(this.currentActIndex);
          // 正解数更新
          this.setActState(true);
        }
        // 再生ボタン非活性
        this.enableAudioReplay = false;
        // 終了ACTindex追加
        this.finishActIndex.push(this.currentActIndex);
        this.showCorrectImg = true;
        // 正解音再生
        this.isCorrectPlaying = true;
        this.audioAnswerCollect();
        this.showAnswers = false;
      } else {
        // 不正解
        // 不正解画像表示
        this.showIncorrectImg = true;
        clearTimeout(this.inncorectTimer);
        this.inncorectTimer = setTimeout(function() {
          self.showIncorrectImg = false;
        }, this.incorrectImageDuration);
        this.audioAnswerIncorrect();
        if (!_.includes(this.incorrectIndex, this.currentActIndex)) {
          this.incorrectIndex.push(this.currentActIndex);
          // 不正解数更新
          this.setActState(false);
        }
      }
    },
    activeCorrectAnswer: function(answer) {
      // 全回答表示中、正解欄をアクティブにする
      var text = this.getRunmodeText(this.currentAct);
      if (this.dispAllAnswerStatus == true && answer == text) {
        // 全解答表示中で正解のテキスト
        return true;
      } else {
        // 上記以外
        return false;
      }
      return true;
    },
    /**
     * 出題文領域自動サイズ調整処理
     */
    autoAdjustTopArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      const self = this;

      // テキスト設定
      const setText = function(topAreaItem, topAreaText, targetText) {
        topAreaItem.children("span").css({ fontSize: mixinConstants.AUTO_ADJUST_FONT_SIZE[self.textSize].max });
        topAreaItem.css("cssText", "height: auto;");
        topAreaText.html(targetText);
      };

      // 出題文領域の高さとフォントサイズを求める
      let topAreaItems = $(".toparea-text > .flexstretch > .item");
      for (let i = 0; i < topAreaItems.length; i++) {
        let topAreaItem = $(topAreaItems.get(i));
        let topAreaText = topAreaItem.children("span");

        let target = this.selectAnswers[i];

        // 英語で実施
        setText(topAreaItem, topAreaText, target.basicText);
        this.usTopAreaFontSize = this.getAutoAdjustFontSize(topAreaItem, topAreaText, this.usTopAreaFontSize);
        // 日本語で実施
        setText(topAreaItem, topAreaText, target.japaneseText);
        this.jpTopAreaFontSize = this.getAutoAdjustFontSize(topAreaItem, topAreaText, this.jpTopAreaFontSize);

        // 初期表示に戻す
        topAreaText.html(this.getSelectListText(target));
      }
    },
    /**
     * 出題文領域サイズ適用
     */
    applyTopAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      // スマホ表示の場合、設定処理を実行
      let topAreaFontSize;
      if (this.dispJapaneseStatus) {
        // 日本語表示
        topAreaFontSize = this.jpTopAreaFontSize;
      } else if (this.runmode == mixinConstants.RUNMODE_NR1) {
        // NR1の場合、英語表示でも日本語が表示されるので日本語のサイズを設定する
        topAreaFontSize = this.jpTopAreaFontSize;
      } else {
        // NR2の英語表示
        topAreaFontSize = this.usTopAreaFontSize;
      }
      // サイズ設定
      let topAreaItems = $(".toparea-text > .flexstretch > .item");
      topAreaItems.css("cssText", "height: auto;");
      topAreaItems.children("span").css({ fontSize: topAreaFontSize });
    }
  },
  watch: {
    lessonState: function(state) {
      // ステータス処理
      if (this.waitingStart && state == constants.LESSON_STATE_START) {
        // STARTの場合、初回音声再生
        this.waitingStart = false;
        this.divideChallenge();
      } else if (state == constants.LESSON_STATE_STOP) {
        // レッスン停止の場合
        this.destroyRunmode();
        this.$emit("stopAct");
      } else if (state == constants.LESSON_STATE_PAUSE) {
        // レッスン停止
        if (!this.myAudio.ended && this.myAudio.paused) {
          // 音声停止中の場合
          this.audioPlaying = true;
        }
        // 次のACT停止
        if (this.nextTimer) {
          clearTimeout(this.nextTimer);
        }
      } else if (state == constants.LESSON_STATE_RESTART) {
        // レッスンリスタート
        if (this.nextTimer) {
          this.nextAct();
        } else if (this.stopNextAct) {
          // 次ACT停止中
          this.stopNextAct = false;
          this.divideChallenge();
        } else if (this.isAudioReplay) {
          // リプレイ中
          this.audioPlaying = false;
          this.isAudioReplay = false;
        } else if (this.isCorrectPlaying) {
          // 正解音再生
          this.audioCollectEnded();
        } else if (!this.myAudio.ended && this.myAudio.paused) {
          // 音声未終了で音声停止中
          if (this.myAudio.paused) {
            this.audioPlaying = true;
            this.myAudio.currentTime = 0;
            this.myAudio.play();
          }
        }
      }
      // 自動調整表示処理
      this.autoAdjustFirstShownNR();
    },
    dispJapaneseStatus: function(newStatus) {
      this.applyTopAreaSize();
      this.applyCardAreaSize();
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
@import "src/assets/style/card";
@import "src/assets/style/nr";

.toparea-text {
  .item {
    &.active {
      border: solid 2px #81af4a;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// NR1.vue?7786563b